export function ResetPasswordFields({
  onOTPChange = (otp: string) => {
    return;
  },
  onPasswordChange = (password: string) => {
    return;
  },
}) {
  return (
    <>
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          OTP
        </label>
        <div className="mt-1">
          <input
            id="otp"
            name="otp"
            type="text"
            required
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm focus:border-[#E5FD6E] focus:outline-none focus:ring-[#E5FD6E] sm:text-sm"
            onChange={(event) => {
              onOTPChange(event.target.value);
            }}
          />
        </div>
      </div>

      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Password
        </label>
        <div className="mt-1">
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm focus:border-[#E5FD6E] focus:outline-none focus:ring-[#E5FD6E] sm:text-sm"
            onChange={(event) => {
              onPasswordChange(event.target.value);
            }}
          />
        </div>
      </div>

      <div className="flex items-center justify-between">
        {/* <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 rounded border-gray-300 text-[#E5FD6E] focus:ring-[#E5FD6E]"
              />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                Remember me
              </label>
            </div> */}
      </div>
    </>
  );
}
